export const flushQueue = () => new Promise(resolve => requestAnimationFrame(resolve))

export const flushQueueDeep = () => new Promise(resolve => setTimeout(resolve, 1))

export const qs = (selector, node = document) => node?.querySelector(selector)

export const qsa = (selector, node = document) => {
  if (Array.isArray(node)) {
    return node.reduce((acc, el) => acc.concat(Array.from(el.querySelectorAll(selector))), [])
  }
  return Array.from(node?.querySelectorAll(selector) ?? [])
}

export const hasClass = (className, node) => Array.from(node?.classList)?.some(c => c.includes(className))

export const wrapLine = (nodes, index) => {
  const _node = document.createElement('span')
  _node.style.setProperty('--line-index', index)
  if (!Array.isArray(nodes)) {
    _node.appendChild(nodes)
  } else {
    nodes.forEach((n, j) => {
      if (j > 0) {
        const _ws = document.createElement('span')
        _ws.className = 'whitespace'
        _ws.innerText = ' '
        _node.appendChild(_ws)
      }
      _node.appendChild(n)
    })
  }

  return _node
}

export const preloadImages = parent => {
  let _parent = parent
  if (typeof parent == 'string') {
    _parent = qs(parent)
  }

  const imgs = qsa('img', _parent)

  if (process.env.NODE_ENV === 'development') { return [ Promise.resolve() ] }

  return imgs
    .filter(img => img.loading !== 'lazy')
    .map(img => new Promise(resolve => {
      if (img.complete) {
        setTimeout(resolve, 0)
      } else {
        img.addEventListener('load', () => { setTimeout(resolve, 0) }, { once: true })
      }
    }))
}

export const isTouchScreen = () =>
  ('ontouchstart' in window)
  || (navigator.maxTouchPoints > 0)
  || (navigator.msMaxTouchPoints > 0)

export const inViewport = (el, store) => {
  const _bgr = el.getBoundingClientRect()
  const _w = store ? store.getters['layout/width'] : (window.innerWidth || document.documentElement.clientWidth)
  const _h = store ? store.getters['layout/height'] : (window.innerHeight || document.documentElement.clientHeight)

  return (
    _bgr.top >= 0
    && _bgr.left >= 0
    && _bgr.bottom <= _h
    && _bgr.right <= _w
  )
}

export const getScrollbarWidth = () => {
  const outer = document.createElement('div')
  outer.style.visibility = 'hidden'
  outer.style.width = '100px'
  document.body.appendChild(outer)

  const widthNoScroll = outer.offsetWidth
  // force scrollbars
  outer.style.overflow = 'scroll'

  // add innerdiv
  const inner = document.createElement('div')
  inner.style.width = '100%'
  outer.appendChild(inner)

  const widthWithScroll = inner.offsetWidth

  // remove divs
  outer.parentNode.removeChild(outer)

  // set css var
  const isTouch = isTouchScreen()

  const r = document.querySelector(':root')
  r.style.setProperty('--scrollbar-width', isTouch ? '0px' : `${widthNoScroll - widthWithScroll}px`)

  return widthNoScroll - widthWithScroll
}

export const getLuminosity = code => {
  if (!code) {
    return null
  }
  const c = code.substring(1)
  const rgb = parseInt(c, 16)
  const r = (rgb >> 16) & 0xff
  const g = (rgb >> 8) & 0xff
  const b = (rgb >> 0) & 0xff
  const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b

  return luma
}
